import React, { useState } from "react";
import { organizationRepo, newShopCode, shopRegisterLink } from "../services";
import { useApp } from "../context/AppContext";
import { useI18n } from "../i18n";
import { Button, Card } from "./ui";
import Icon from "./ui/Icon";

// การ์ดรหัสร้าน + ลิงก์สมัครของลูกค้า — ใช้ทั้งหน้าแพ็กเกจ แดชบอร์ด และข้อมูลองค์กร
// (หน้าแพ็กเกจเข้าได้เสมอ ร้านที่ยังไม่ซื้อแพ็กเกจจึงยังเห็นลิงก์ของตัวเอง)
export default function ShopLinkCard() {
  const { organization, planFree, limitOf, refreshOrganizations, toast } = useApp();
  const { tx } = useI18n();
  const [saving, setSaving] = useState(false);

  if (!organization) return null;

  // ร้านที่สร้างก่อนระบบแยกร้านยังไม่มีรหัส — ออกให้ใหม่ได้จากการ์ดนี้
  const issueCode = async () => {
    setSaving(true);
    await organizationRepo.update(null, organization.id, { code: newShopCode() });
    await refreshOrganizations();
    setSaving(false);
    toast(tx("ออกรหัสร้านเรียบร้อย", "Shop code created"), "success");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shopRegisterLink(organization.code));
      toast(tx("คัดลอกลิงก์แล้ว", "Link copied"), "success");
    } catch (e) {
      toast(tx("คัดลอกไม่สำเร็จ", "Copy failed"), "error");
    }
  };

  return (
    <Card title={tx("ลิงก์สมัครสมาชิกของลูกค้า", "Customer sign-up link")} subtitle={tx("ลูกค้าที่สมัครผ่านลิงก์นี้จะอยู่ในร้านนี้เท่านั้น", "Customers signing up here belong to this shop only")}>
      {organization.code ? (
        <>
          <div className="u-fs-13 u-muted">{tx("รหัสร้าน", "Shop code")}</div>
          <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: 2 }}>{organization.code}</div>
          <div className="u-fs-13 u-muted u-mt-8">{tx("ลิงก์สมัคร", "Sign-up link")}</div>
          <div className="u-fs-13" style={{ wordBreak: "break-all" }}>{shopRegisterLink(organization.code)}</div>
          <Button className="u-mt-8" size="sm" onClick={copyLink}>
            <Icon name="copy" /> {tx("คัดลอกลิงก์", "Copy link")}
          </Button>
          {/* ชุดฟรีรับลูกค้าได้จำกัด — บอกไว้ตรงนี้ ร้านจะได้ไม่งงว่าทำไมลูกค้าสมัครไม่ได้เมื่อเต็ม */}
          {planFree ? (
            <div className="u-fs-12 u-muted u-mt-8">
              {tx(`ใช้งานฟรีรับลูกค้าได้ ${limitOf("customers")} คน — ซื้อแพ็กเกจเพื่อรับเพิ่ม`, `Free shops can have up to ${limitOf("customers")} customers — buy a plan for more`)}
            </div>
          ) : null}
        </>
      ) : (
        <>
          <div className="u-fs-13 u-muted u-mb-8">
            {tx("ร้านนี้ยังไม่มีรหัสร้าน จึงยังรับสมัครลูกค้าไม่ได้", "This shop has no code yet, so customers cannot sign up")}
          </div>
          <Button variant="primary" size="sm" onClick={issueCode} disabled={saving}>
            {tx("ออกรหัสร้าน", "Create shop code")}
          </Button>
        </>
      )}
    </Card>
  );
}
